import { getUserSelectedCurrencyCode } from '@/src/utils/currency/getCurrencyCode'
import { isUserSignedIn } from '@/src/utils/generalUtils/checkUserLogin'
import { path } from '@/src/utils/generalUtils/path'
import { getGtmPageCountry } from '@/src/utils/analytics/gtm/getGtmPageCountry'
import { useLocale } from 'next-intl'
import { usePathname } from 'next/navigation'
import { useCallback } from 'react'
import useClevertapEvent from '../index'

const useClevertapForHomepage = () => {
    const { triggerEvent } = useClevertapEvent()
    const locale = useLocale()
    const pathname = usePathname()

    const triggerHomepageLoadEvent = useCallback(
        (name: string) => {
            // Determine if it's flights homepage based on pathname
            const isFlightsPage = pathname?.includes('/flights') || false

            // Determine page_name based on route
            const page_name = isFlightsPage ? 'flights_homepage' : 'homepage'

            // Get hostname and domain
            const hostname = typeof window !== 'undefined' ? window.location.hostname : 'NA'
            const domain = typeof window !== 'undefined' ? path(['location', 'hostname'], window) || 'NA' : 'NA'

            // Get page country
            const page_country = getGtmPageCountry(hostname)

            // Get currency
            const page_currency = getUserSelectedCurrencyCode()?.toLowerCase() || 'sar'

            // Get login status
            const is_logged_in = isUserSignedIn() ? 'yes' : 'no'

            // Get page path
            const page_path = pathname || '/'

            // Determine current_page
            const current_page = isFlightsPage ? 'flights_homepage' : 'homepage'

            const finalPayload = {
                hostname,
                domain,
                page_name,
                is_logged_in,
                page_language: locale,
                page_path,
                page_country,
                page_currency,
                current_page
            }
            console.log('[CleverTap]' + name + ' (homepage):', finalPayload)

            triggerEvent(name, finalPayload)
        },
        [triggerEvent, locale, pathname]
    )

    return {
        triggerHomepageLoadEvent
    }
}

export default useClevertapForHomepage
